import React from 'react';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IProps {
	isTipsSupported: boolean;
}

export const DisplayTipsCheckbox: React.FC<IProps> = ({ isTipsSupported }) => {
	const { t } = useTranslation('form');
	const inputValue = isTipsSupported ? t('yes') : t('no');

	return (
		<FullInfoField
			label="bankSettingsDisplayTipsLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isTipsSupported ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isTipsSupported}
		/>
	);
};
